export { ButtonCheckboxDirective } from './button-checkbox.directive';
export { ButtonRadioDirective } from './button-radio.directive';
export { ButtonsModule } from './buttons.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/ng2-bootstrap/buttons/index.js
// module id = ../../../../ng2-bootstrap/buttons/index.js
// module chunks = 4